// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__30dPA","type":"styles_type__EThXL","choices":"styles_choices__3XPVc"};